import React from "react";
import { Button } from "./Button";

export interface TileData {
  title: string;
  text: string;
  image: string;
  imageStyle?: React.CSSProperties;
  imageClassName?: string;
  tileStyles?: React.CSSProperties;
  fullText: string;
  actionButton?: {
    text: string;
    onClick?: () => void;
    rightIcon?: string;
    className?: string;
    navigateTo?: string;
  };
}

interface HorizontalTileProps extends TileData {
  onLearnMore: (tileData: TileData) => void;
}

export const HorizontalTile: React.FC<HorizontalTileProps> = ({
  title,
  text,
  image,
  imageStyle,
  onLearnMore,
  tileStyles,
  fullText,
  actionButton,
}) => (
  <div className="whats-new-tile w-full !pt-8" style={tileStyles}>
    <div className="whats-new-tile-content w-full">
      {/* Desktop and Tablet Layout */}
      <div className="flex flex-row items-center desktop-tablet-layout w-full">
        <div className="flex flex-col flex-1">
          <h4 className="whats-new-tile-title text-left lg:ml-16">{title}</h4>
          <span className="whats-new-tile-text lg:ml-16 !font-[300]">{text}</span>
          <div className="mt-4 lg:mt-6 flex justify-start lg:ml-16">
            <Button
              text="LEARN MORE"
              rightIcon="+"
              onClick={() =>
                onLearnMore({ title, text, image, imageStyle, fullText, actionButton })
              }
            />
          </div>
        </div>
        <div className="flex justify-center items-center w-[30%] lg:w-[20%] min-w-0 rounded-[10px]">
          <img
            style={imageStyle}
            className="whats-new-tile-image rounded-[10px]"
            src={image}
            alt={title}
          />
        </div>
      </div>
      
      {/* Mobile Layout */}
      <div className="flex flex-col items-center mobile-layout">
        <div className="flex flex-col w-full justify-center mb-4 px-4">
          <h4 className="whats-new-tile-title text-center">{title}</h4>
          <span className="whats-new-tile-text text-center">{text}</span>
        </div>
        <div className="flex justify-center items-center w-full mb-4 px-4 rounded-[10px]">
          <img
            style={imageStyle}
            className="whats-new-tile-image rounded-[10px]"
            src={image}
            alt={title}
          />
        </div>
        <div className="flex justify-center w-full px-4">
          <Button
            text="LEARN MORE"
            rightIcon="+"
            onClick={() =>
              onLearnMore({ title, text, image, imageStyle, fullText, actionButton })
            }
          />
        </div>
      </div>
    </div>
  </div>
);
